import React from 'react';
import { Download, InfoOutline } from '@yme/assets/icons';
import { GHOST_VARIANT, ICON_ONLY, BTN_LIGHT_THEME, SIZE_44 } from '@yme/atoms/button';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { DisclaimerStyled, DownloadButtonMobileStyled, DownloadButtonStyled, InfoContainerFooterStyled, InfoContainerStyled, LightboxCounter, } from './styled';
export function InfoContainer({ amount, currentItem, isInLightbox, isMobile, isImage, photoDisclaimers, downloadButtonLabel, onDownload, isRightToLeft, }) {
    const { isInfiniteDesktopView } = useWindowSize();
    if (!isInLightbox) {
        return null;
    }
    if (isMobile && !isInfiniteDesktopView) {
        return (React.createElement(InfoContainerStyled, { isMobile: true },
            isImage && (React.createElement(DownloadButtonMobileStyled, { buttonVariant: GHOST_VARIANT, hasIconButton: ICON_ONLY, iconComponent: Download, colorSchema: BTN_LIGHT_THEME, label: downloadButtonLabel, onClick: onDownload, size: SIZE_44 })),
            React.createElement(LightboxCounter, { isRightToLeft: isRightToLeft, currentItem: currentItem, amount: amount })));
    }
    return !isMobile ? (React.createElement(InfoContainerFooterStyled, null,
        photoDisclaimers?.map((photoDisclaimer) => (React.createElement(DisclaimerStyled, { key: photoDisclaimer, isRightToLeft: isRightToLeft },
            React.createElement(SVGIcon, { type: InfoOutline, pathFill: colorCoreBlack900Base }),
            photoDisclaimer))),
        downloadButtonLabel && isInfiniteDesktopView && isImage && (React.createElement(DownloadButtonStyled, { onClick: onDownload, iconType: Download, isRTL: isRightToLeft }, downloadButtonLabel)))) : null;
}
